import AccountsServices from '@/services/accounts'
import CitiesServices from '@/services/cities'

function createCityIfDoesNotExist (state, cityId)
{
    if (!state.cities[cityId]) state.cities[cityId] = {}
    if (!state.cities[cityId].administrators) state.cities[cityId].administrators = {}
}

export default
{
    namespaced: true,
    
    state:
    {
        cities: { }
    },

    getters:
    {
        getCityAdministratorsById: state => id =>
        {
            createCityIfDoesNotExist(state, id)
            
            return state.cities[id].administrators
        },

        getAccountPrivileges: state => ({ cityId, accountId }) =>
        {
            createCityIfDoesNotExist(state, cityId)
            
            return (state.cities[cityId].administrators[accountId] || {}).privileges || {}
        },
    },
    
    mutations:
    {
        updateCityAdministrators (state, {cityId, administrators = {}} = {}) 
        {
            createCityIfDoesNotExist(state, cityId)

            for (const userId in administrators)
            {
                const user = administrators[userId]
                let storedAdministrator = state.cities[cityId].administrators[userId] || {}
                storedAdministrator = { ...storedAdministrator, ...user }
                storedAdministrator.privileges = { ...storedAdministrator.privileges, ...user.privileges }

                state.cities[cityId].administrators[userId] = storedAdministrator

                if (!storedAdministrator.privileges.isAdministrator)
                {
                    console.log('Administrator', storedAdministrator, 'does not have the administrator privilege anymore. Deleting..')
                    delete state.cities[cityId].administrators[userId]
                }
                
                // used to trigger reactivity
                state.cities = { ...state.cities }
            }
        },

        remove (state, { cityId, adminId } = {})
        {
            createCityIfDoesNotExist(state, cityId)

            delete state.cities[cityId].administrators[adminId]
        }
    },

    actions:
    {
        async fetchAdministratorAccount (context, { cityId, token, accountId })
        {
            const userPrivileges = await CitiesServices.getUserPrivileges(cityId, token, accountId)

            if (!userPrivileges.isAdministrator)
            {
                return console.log(`Fetched administrator info for account ${accountId} of city ${cityId}, account is not admin.`)
            }

            const accountInfo = await AccountsServices.searchAccount(accountId, cityId)

            const user = { ...accountInfo, privileges: userPrivileges }

            await context.commit('updateCityAdministrators', { cityId, administrators: { [accountId]: user } })
        }
    }
}


// WEBPACK FOOTER //
// ./src/stores/cities.js